import { render, staticRenderFns } from "./fenxiang.vue?vue&type=template&id=6a899751&scoped=true&"
import script from "./fenxiang.vue?vue&type=script&lang=js&"
export * from "./fenxiang.vue?vue&type=script&lang=js&"
import style0 from "./fenxiang.vue?vue&type=style&index=0&id=6a899751&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a899751",
  null
  
)

export default component.exports